import { toast } from 'react-toastify';

export const toastSuccess =(msg) =>{
    toast.success(msg, {
        position: "bottom-right"
      });
} 

export const toastError =(msg) =>{
    toast.error(msg, {
        position: "top-right"
      });
} 

export const toastWarning =(msg) =>{
    toast.warn(msg, {
        position: "top-right"
      });
} 

export const toastInfo =(msg) =>{
    toast.info(msg, {
        position: "top-right"
      });
} 
